import { HttpMethod } from '@teqplay/api'

import { requestBuilder } from '../builder'

export type TPortInfrastructureBerth = {
  id: string
  name: string
  unlocode: string
  location: {
    lat: number
    lon: number
  }
  area: Array<{
    lat: number
    lon: number
  }>
}

export type TGetPortInfrastructureBerthInput = { unlocode: string }
export type TGetPortInfrastructureBerthOutput = TPortInfrastructureBerth[]

const getBerth = requestBuilder
  .type<TGetPortInfrastructureBerthInput, TGetPortInfrastructureBerthOutput>()
  .request(({ input: { unlocode } }) => ({
    path: `/v1/portInfrastructure/berth/${encodeURIComponent(unlocode)}`,
    method: HttpMethod.GET
  }))

const portInfrastructure = { getBerth }
export default portInfrastructure
